module.exports = __webpack_public_path__ + "img/10D.7e448065.svg";